import { render, staticRenderFns } from "./VozGuidelineAdaptableSection.vue?vue&type=template&id=5a7a896c"
import script from "./VozGuidelineAdaptableSection.vue?vue&type=script&lang=ts"
export * from "./VozGuidelineAdaptableSection.vue?vue&type=script&lang=ts"
import style0 from "./VozGuidelineAdaptableSection.vue?vue&type=style&index=0&id=5a7a896c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports